import * as ReactGA from "react-ga";
import {GAActionKeys, GACategories} from "./GoogleAnalyticsKeys";
import {
    ITechReferenceSheet,
    IBlank,
    IBranding,
    ICoverImage,
    ICrop,
    IDisclaimer,
    IDocument, IFillerImage,
    ILogo,
    IOrder,
    IProduct,
    IProductLogo, ISeedIcon,
    ISeedProductClone,
    ISeedProductSubmit,
    ITechSheet,
    ITagline,
    IUserData
} from "./interfaces";
import {googleAnalyticsID, isProductionEnvironment} from "../config";

export const configureAfterLogin = (user: IUserData) => {
    const gaOptions: ReactGA.GaOptions = {
    }
    const options: ReactGA.InitializeOptions = {
        gaOptions,
        debug: !isProductionEnvironment(),
    };
    ReactGA.initialize(googleAnalyticsID, options);
    ReactGA.event({
        category: GACategories.AUTHENTICATION,
        action: GAActionKeys.LOGIN,
        value: +(user.id)
    });
};

export const placedOrder = (order: IOrder) => {
    if (order.orderQuantitiesAddresses.length > 0) {
        const orderState = order.orderQuantitiesAddresses[0].address.shipState;
        const orderQuantity = order.orderQuantitiesAddresses.map(o => o.orderQuantity).reduce((acc, x) => (acc + x));
        ReactGA.event({
            category: GACategories.ORDERS,
            action: GAActionKeys.ORDER,
            label: orderState,
            value: orderQuantity,
        });
    }
}
export const downloadedPDF = (document: IDocument) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.DOWNLOADED_PDF,
        label: document.name,
        value: document.id,
    });
}
export const downloadedCSV = () => {
    ReactGA.event({
        category: GACategories.REPORTING,
        action: GAActionKeys.DOWNLOADED_CSV,
    });
}
export const downloadedTechSheets = (categoryName: string) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.DOWNLOADED_TECH_SHEETS,
        label: categoryName,
    });
}
export const changedOrderStatus = (order: IOrder) => {
    ReactGA.event({
        category: GACategories.ORDERS,
        action: GAActionKeys.ORDER_STATUS_CHANGE,
        value: order.status_id,
    });
}
export const deleteOrder = (order: IOrder) => {
    ReactGA.event({
        category: GACategories.ORDERS,
        action: GAActionKeys.ORDER_DELETE,
        value: order.status_id,
    });
}
export const createNewProduct = (product: IProduct) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.PRODUCT_CREATE,
        label: product.name,
        value: product.id,
    });
}
export const editProduct = (product: IProduct) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.PRODUCT_EDIT,
        label: product.name,
        value: product.id,
    });
}
export const createNewSeed = (seed: ISeedProductSubmit) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_CREATE,
        label: seed.name,
        value: seed.id,
    });
}
export const cloneSeed = (seed: ISeedProductClone) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_CLONE,
        value: seed.seedToCloneId,
    });
}
export const editSeed = (seed: ISeedProductSubmit) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_EDIT,
        label: seed.name,
        value: seed.id,
    });
}
export const deleteProduct = (product: IProduct) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.PRODUCT_DELETE,
        label: product.name,
        value: product.id,
    });
}
export const publishProduct = (product: IProduct) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.PRODUCT_PUBLISH,
        label: product.name,
        value: product.id,
    });
}
export const unpublishProduct = (product: IProduct) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.PRODUCT_UNPUBLISH,
        label: product.name,
        value: product.id,
    });
}
export const publishSeed = (seed: ISeedProductSubmit) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_PUBLISH,
        label: seed.name,
        value: seed.id,
    });
}
export const unpublishSeed = (seed: ISeedProductSubmit) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_UNPUBLISH,
        label: seed.name,
        value: seed.id,
    });
}
export const createAgronomyReferenceSheet = (agronomyReferenceSheet: ITechReferenceSheet) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.AGRONOMY_REFERENCE_SHEET_CREATE,
        label: agronomyReferenceSheet.title,
        value: agronomyReferenceSheet.id,
    });
}
export const editAgronomyReferenceSheet = (agronomyReferenceSheet: ITechReferenceSheet) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.AGRONOMY_REFERENCE_SHEET_EDIT,
        label: agronomyReferenceSheet.title,
        value: agronomyReferenceSheet.id,
    });
}
export const publishAgronomyReferenceSheet = (agronomyReferenceSheet: ITechReferenceSheet) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.AGRONOMY_REFERENCE_SHEET_PUBLISH,
        label: agronomyReferenceSheet.title,
        value: agronomyReferenceSheet.id,
    });
}
export const unpublishAgronomyReferenceSheet = (agronomyReferenceSheet: ITechReferenceSheet) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.AGRONOMY_REFERENCE_SHEET_UNPUBLISH,
        label: agronomyReferenceSheet.title,
        value: agronomyReferenceSheet.id,
    });
}

export const createTechSheet = (techSheet: ITechSheet) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_TECH_SHEET_CREATE,
        label: techSheet.name,
        value: techSheet.id,
    });
}
export const publishTechSheet = (techSheet: ITechSheet) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_TECH_SHEET_PUBLISH,
        label: techSheet.name,
        value: techSheet.id,
    });
}
export const unpublishTechSheet = (techSheet: ITechSheet) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_TECH_SHEET_UNPUBLISH,
        label: techSheet.name,
        value: techSheet.id,
    });
}
export const catalogCreateFullscreenImage = (blank: IBlank) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.CATALOG_CREATE_FULLSCREEN_IMAGE,
        label: blank.title,
        value: blank.id,
    });
}
export const catalogUpdateFullscreenImage = (blank: IBlank) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.CATALOG_UPDATE_FULLSCREEN_IMAGE,
        label: blank.title,
        value: blank.id,
    });
}
export const createSeedIcon = (seedIcon: ISeedIcon) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_ICON_CREATE,
        label: seedIcon.name,
        value: seedIcon.id,
    });
}
export const publishSeedIcon = (seedIcon: ISeedIcon) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_ICON_PUBLISH,
        value: seedIcon.id,
    });
}
export const unpublishSeedIcon = (seedIcon: ISeedIcon) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_ICON_UNPUBLISH,
        value: seedIcon.id,
    });
}
export const editSeedIcon = (seedIcon: ISeedIcon) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_ICON_EDIT,
        value: seedIcon.id,
    });
}
export const deleteSeedIcon = (seedIcon: ISeedIcon) => {
    ReactGA.event({
        category: GACategories.SEEDS,
        action: GAActionKeys.SEED_ICON_DELETE,
        value: seedIcon.id,
    });
}

export const createFillerImage = (fillerImage: IFillerImage) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.FILLER_IMAGE_CREATE,
        label: fillerImage.name,
        value: fillerImage.id,
    });
}
export const editFillerImage = (fillerImage: IFillerImage) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.FILLER_IMAGE_EDIT,
        value: fillerImage.id,
    });
}
export const deleteFillerImage = (fillerImage: IFillerImage) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.FILLER_IMAGE_DELETE,
        value: fillerImage.id,
    });
}

export const publishCatalogCreateFullscreenImage = (blank: IBlank) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.CATALOG_CREATE_FULLSCREEN_IMAGE_PUBLISH,
        label: blank.title,
        value: blank.id,
    });
}
export const unpublishCatalogCreateFullscreenImage = (blank: IBlank) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.CATALOG_CREATE_FULLSCREEN_IMAGE_UNPUBLISH,
        label: blank.title,
        value: blank.id,
    });
}
export const createProductLogo = (logo: IProductLogo) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.LOGO_CREATE,
        label: logo.src,
        value: +logo.id,
    });
}
export const archiveProductLogo = (logo: IProductLogo) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.LOGO_ARCHIVE,
        label: logo.src,
        value: +logo.id,
    });
}
export const editProductLogo = (logo: IProductLogo) => {
    ReactGA.event({
        category: GACategories.PRODUCTS,
        action: GAActionKeys.LOGO_EDIT,
        label: logo.src,
        value: +logo.id,
    });
}
export const createComplimentaryLogo = (logo: ILogo) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.LOGO_COMPLIMENTARY_CREATE,
        label: logo.title,
        value: logo.id,
    });
}
export const deleteComplimentaryLogo = (logo: ILogo) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.LOGO_COMPLIMENTARY_DELETE,
        label: logo.title,
        value: logo.id,
    });
}
export const editComplimentaryLogo = (logo: ILogo) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.LOGO_COMPLIMENTARY_EDIT,
        label: logo.title,
        value: logo.id,
    });
}
export const createBranding = (branding: IBranding) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.BRANDING_CREATE,
        label: branding.title,
        value: branding.id,
    });
}
export const deleteBranding = (branding: IBranding) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.BRANDING_DELETE,
        label: branding.title,
        value: branding.id,
    });
}
export const editBranding = (branding: IBranding) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.BRANDING_EDIT,
        label: branding.title,
        value: branding.id,
    });
}
export const createFullscreenCover = (cover: ICoverImage) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.COVER_CREATE,
        label: cover.title,
        value: cover.id,
    });
}
export const deleteFullscreenCover = (cover: ICoverImage) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.COVER_DELETE,
        label: cover.title,
        value: cover.id,
    });
}
export const createSmallCoverImage = (coverImage: ICrop) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.COVER_IMAGE_SMALL_CREATE,
        label: coverImage.name,
        value: coverImage.id,
    });
}
export const deleteSmallCoverImage = (coverImage: ICrop) => {
    ReactGA.event({
        category: GACategories.DOCUMENTS,
        action: GAActionKeys.COVER_IMAGE_SMALL_DELETE,
        label: coverImage.name,
        value: coverImage.id,
    });
}
export const createDisclaimer = (disclaimer: IDisclaimer) => {
    ReactGA.event(({
            category: GACategories.DISCLAIMERS,
            action: GAActionKeys.DISCLAIMER_CREATE,
            label: disclaimer.description,
            value: disclaimer.id,
        }
    ));
}
export const editDisclaimer = (disclaimer: IDisclaimer) => {
    ReactGA.event(({
            category: GACategories.DISCLAIMERS,
            action: GAActionKeys.DISCLAIMER_EDIT,
            label: disclaimer.description,
            value: disclaimer.id,
        }
    ));
}
export const deleteDisclaimer = (disclaimer: IDisclaimer) => {
    ReactGA.event(({
            category: GACategories.DISCLAIMERS,
            action: GAActionKeys.DISCLAIMER_DELETE,
            label: disclaimer.description,
            value: disclaimer.id,
        }
    ));
}

export const createTagline = (tagline: ITagline) => {
    ReactGA.event(({
            category: GACategories.TAGLINES,
            action: GAActionKeys.TAGLINE_CREATE,
            label: tagline.title,
            value: tagline.id,
        }
    ));
}
export const editTagline = (tagline: ITagline) => {
    ReactGA.event(({
            category: GACategories.TAGLINES,
            action: GAActionKeys.TAGLINE_EDIT,
            label: tagline.title,
            value: tagline.id,
        }
    ));
}
export const deleteTagline = (tagline: ITagline) => {
    ReactGA.event(({
            category: GACategories.TAGLINES,
            action: GAActionKeys.TAGLINE_DELETE,
            label: tagline.title,
            value: tagline.id,
        }
    ));
}



// WEBPACK FOOTER //
// ./src/infrastructure/GoogleAnalyticsEvents.ts